import React, { useEffect, useState, Component, useContext } from 'react';
import FooterTwo from './components/FooterTwo';
import HeaderNew from './components/HeaderNew';
import AboutUsNew from './components/AboutUsNew';
import BenefitsSection from './components/BenefitsSection';
import CourseSection from './components/CourseSection';
import HeroImageNew from './components/HeroImageNew';
import HearderSearchCourseList from './components/HearderSearchCourseList';
import { useDispatch, useSelector } from 'react-redux';
import './homenew.css';

function HomeNew(props) {
    let searchValue = useSelector(state => state.inputValue);
    return (<>

        <HeaderNew />
        <div style={{ paddingTop: "140px"}}>

            <HeroImageNew />

            {/* <Features/> */}

            <CourseSection />

            <BenefitsSection />

            < AboutUsNew />

            < FooterTwo />

        </div>
    </>);
}
export default HomeNew;